<template>
    <div>
        <config-main-title v-if="aba">
            {{ aba.search }}
        </config-main-title>

        <az-loading v-if="loading" />

        <div v-if="aba && aba.st_conteudo" class="mb-3">
            <span v-html="aba.conteudo"></span>
        </div>

        <template v-if="aba && aba.arqs && aba.arqs.length">
            <div class="list-group">
                <a :href="arquivo.temporary_url" target="_blank" class="list-group-item list-group-item-action" v-for="(arquivo, iax) in aba.arqs" :key="iax">
                    {{ arquivo.st_titulo }}
                </a>
            </div>
        </template>

        <template v-if="aba && aba.arquivos && aba.arquivos.length">
            <div class="list-group">
                <a :href="arquivo.arquivo.temporary_url" target="_blank" class="list-group-item list-group-item-action" v-for="(arquivo, iax) in aba.arquivos" :key="iax">
                    {{ arquivo.arquivo.st_titulo }}
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue'; 
import AzLoading from '../util/AzLoading.vue';

export default {
    data() {
        return { 
            aba: null, 
            loading: false, 
        }
    },

    components: { 
        ConfigMainTitle, 
        AzLoading, 
    },

    props: ['id'],

    watch: { 
        id: function () { 
            this.abrir();
        }
    },

    methods: { 
        abrir() { 
            this.aba = this.$store.state.user.abas.find(aba => aba.id_apoiado_portal_aba == this.id);

            this.$util.load(this, { 
                service: 'apoiados',
                func: 'aba', 
                parms: { 
                    id: this.id, 
                }, 
                loadTo: res => { 
                    this.aba = res.aba;
                }
            });

            //console.log("Abrir aba " + this.id);
        }
    },

    mounted() { 
        this.abrir();
    }
}
</script>
